import { NgModule } from '@angular/core';
import { MaterialModule } from '../core/material.module';
import { SharedModule } from '../core/shared.module';
import { FilterEmptyStateComponent } from './filter-empty-state/filter-empty-state.component';
import { FilterFilteringComponent } from './filter-filtering/filter-filtering.component';
import { FilterSearchComponent } from './filter-search/filter-search.component';
import { FilterSelectedFiltersComponent } from './filter-selected-filters/filter-selected-filters.component';
import { FilterSelectedSortsComponent } from './filter-selected-sorts/filter-selected-sorts.component';
import { FilterSortComponent } from './filter-sort.component';
import { FilterSortingComponent } from './filter-sorting/filter-sorting.component';
import { FilterMultiSelectSearchComponent } from './filters/filter-multi-select-search/filter-multi-select-search.component';
import { FilterMultiSelectComponent } from './filters/filter-multi-select/filter-multi-select.component';
import { FilterSingleSelectCombinationComponent } from './filters/filter-single-select-combination/filter-single-select-combination.component';
import { FilterSingleSelectDateRangeComponent } from './filters/filter-single-select-date-range/filter-single-select-date-range.component';
import { FilterSingleSelectSearchComponent } from './filters/filter-single-select-search/filter-single-select-search.component';
import { FilterSingleSelectComponent } from './filters/filter-single-select/filter-single-select.component';
import { FilterToggleComponent } from './filters/filter-toggle/filter-toggle.component';
import { SearchEmptyStateComponent } from './search-empty-state/search-empty-state.component';
import { SortDirectionSelectComponent } from './sorts/sort-direction-select/sort-direction-select.component';

@NgModule({
    declarations: [
        FilterSortComponent,
        FilterSingleSelectSearchComponent,
        FilterMultiSelectSearchComponent,
        FilterSingleSelectDateRangeComponent,
        FilterToggleComponent,
        FilterSingleSelectComponent,
        FilterMultiSelectComponent,
        FilterSingleSelectCombinationComponent,
        FilterSearchComponent,
        FilterSortingComponent,
        SortDirectionSelectComponent,
        FilterSelectedFiltersComponent,
        FilterSelectedSortsComponent,
        FilterFilteringComponent,
        FilterEmptyStateComponent,
        SearchEmptyStateComponent
    ],
    imports: [MaterialModule, SharedModule],
    providers: [],
    exports: [
        FilterSortComponent,
        FilterEmptyStateComponent,
        SearchEmptyStateComponent
    ],
    bootstrap: []
})
export class FilterModule {}
